import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const VendorContactContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const ContactModalContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',

  '.rowFields': {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
})

export const ActionButtonContainer = styled.div({
  display: 'flex', 
  button: { 
    span: { 
      'svg.MuiSvgIcon-root': { 
        fontSize: '1.1rem',
      } 
    }
  }
})
